import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledInfoTypography, StyledTitleWrapper } from './styled';

const SectionsHeader = () => {
  const { t } = useTranslation();

  return (
    <StyledTitleWrapper>
      <StyledInfoTypography variant="h2">
        {t('discoveryPage:sections:header:title')}
      </StyledInfoTypography>
      <Typography>{t('discoveryPage:sections:header:description')}</Typography>
    </StyledTitleWrapper>
  );
};

export default SectionsHeader;
